module.exports = __webpack_public_path__ + "img/25_14.87bc6041.png";